export enum InteractiveVideosEventType {
  INTERACTIVE_VIDEOS_OUTCOME_EVENT = 'interactive_videos_outcome_event',
  INTERACTIVE_VIDEOS_REPORT_ACTIVITY_PROGRESS_EVENT = 'interactive_videos_report_activity_progress_event',
  INTERACTIVE_VIDEOS_CLOSE_EVENT = 'interactive_videos_close_event',
  INTERACTIVE_VIDEOS_HEIGHT_EVENT = 'interactive_videos_height_event',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/interactive-videos-events.enum.ts